import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const NewProjectProjectMeetingReplyNotifCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl
    ? `قام ${sender.name} بالرد على دعوتك للإجتماع`
    : `${sender.name} replied to your meeting invitation`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default NewProjectProjectMeetingReplyNotifCover
